import { EFeatureFlag, LocalDataKeys, TFeatureFlags } from '@libs/types';
import { getLocalDataSnapshot, saveLocalData } from './utils/localDataStore';

/**
 * Persists `configuration.featureFlags` from a scenario response, merged per flag into the stored ones. A response
 * without flags, or without one flag, keeps the stored value: the backend sends them only with `requestInteraction`,
 * and they must survive a reload.
 */
export const saveFeatureFlags = (featureFlags: TFeatureFlags | undefined): void => {
    if (featureFlags) {
        saveLocalData(LocalDataKeys.featureFlags, { ...getLocalDataSnapshot<TFeatureFlags>(LocalDataKeys.featureFlags), ...featureFlags });
    }
};

/** Last stored value of a backend feature flag, or `undefined` when the backend never sent it. */
export const getFeatureFlag = (flag: EFeatureFlag): boolean | undefined => getLocalDataSnapshot<TFeatureFlags>(LocalDataKeys.featureFlags)?.[flag];
